import { Base64 } from 'js-base64';
import utf8 from 'utf8';
import Vue from 'vue';
import { mapState } from 'vuex';
import store from '../store';

export default Vue.component('successLogin', {
  async created() {
    const tokenDecode = Base64.decode(this.$route.params.token);
    const token = utf8.decode(tokenDecode);
    this.$cookies.set('accessToken', token);
    await store.dispatch('user/VerifyTokenEmailSave', token);
    if (!this.verifyTokenEmail) {
      this.$router.push('/login');
    } else {
      await store.dispatch('user/saveUserStore', this.verifyTokenEmail);
      this.$router.push('/');
    }
  },
  render: () => '<div></div>',
  computed: {
    ...mapState('user', ['verifyTokenEmail']),
  },
});
